import { motion } from 'framer-motion';
import { Footer } from '@/components/Footer';

// Sections
import { HeroSection } from '@/components/sections/HeroSection';
import { PhilosophySection } from '@/components/sections/PhilosophySection';
import { AwardsSection } from '@/components/sections/AwardsSection';
import { ProjectsSection } from '@/components/sections/ProjectsSection';
import { ServicesSection } from '@/components/sections/ServicesSection';
import { GallerySection } from '@/components/sections/GallerySection';
import { ContactSection } from '@/components/sections/ContactSection';

export const HomePage = ({ apiSettings = null }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <main>
        <HeroSection apiSettings={apiSettings} />
        <PhilosophySection apiSettings={apiSettings} />
        <ProjectsSection apiSettings={apiSettings} />
        <AwardsSection />
        <GallerySection apiSettings={apiSettings} />
        <ServicesSection />
        <ContactSection apiSettings={apiSettings} />
      </main>
      <Footer />
    </motion.div>
  );
};

export default HomePage;